module.exports = __webpack_public_path__ + "img/check.a9e06db0.svg";